'use client';

import { cn } from '@sunfish/lib/utils';
import { SunfishMark } from './sunfish-mark';

export function Logo({ className }: { className?: string }) {
	return (
		<div className={cn('text-brand', className)}>
			<SunfishMark />
		</div>
	);
}
